function abTestApiFactory(storefrontApiClient) {
  const abTestApi = {
    getAbTests(params, cacheSettings) {
      return storefrontApiClient.get('/abtest',
        {params},
        cacheSettings,
      );
    },
  };

  return abTestApi;
}

export default abTestApiFactory;
